import { Splide, SplideSlide } from '@splidejs/react-splide';
import { get, map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { cn } from 'utils/Tailwind';

import '@splidejs/react-splide/css';

export const EVENTS = {
  SELECT_HERO_SLIDE: 'selectHeroSlide',
};

const CAROUSEL_OPTIONS = {
  arrows: false,
  autoplay: true,
  drag: false,
  interval: 5000,
  pagination: false,
  paginationDirection: 'ttb',
  pauseOnHover: false,
  rewind: true,
  speed: 0,
  type: 'fade',
};

const HeroCarousel = ({ children }) => {
  return (
    <div className="HeroCarousel relative aspect-4/5 md:aspect-[1/.43]">
      <Splide
        data-testid="splide"
        className="!absolute inset-0"
        options={{
          ...CAROUSEL_OPTIONS,
          ...(children.length > 1 && { pagination: true }),
        }}
      >
        {map(children, (slide, index) => (
          <SplideSlide
            key={get(slide, 'internalName') || index}
            className={cn('HeroCarousel__slide aspect-4/5 md:aspect-[1/.43]', {})}
          >
            {slide}
          </SplideSlide>
        ))}
      </Splide>
    </div>
  );
};

HeroCarousel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  interval: PropTypes.number,
  height: PropTypes.number,
};

export default HeroCarousel;
